import {Component, Input} from "@angular/core";
import {ReportModel} from "@fedeltapointofsale/data-client";
import {EditService} from "../../../framework/entity/edit/edit-page/edit.service";

@Component({
    selector: "wbo-tax-inclusive-report-criteria",
    templateUrl: "./tax-inclusive-report-criteria.component.html"
})
export class TaxInclusiveReportCriteriaComponent {
    constructor(public model: ReportModel<any>, public editService: EditService) {
    }
}
